import React from 'react'
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core'
import { TFunction } from 'react-i18next'
import CMSText from '../Global/CMSText'
import { PrismicShop } from '@/interfaces/common/prismicShop'
import { SortValue, useShopSorting } from '@/hooks/useShopSorting'

type FilterDrawerSortProps = {
  doc: PrismicShop
  sort: SortValue
  onSortChange: (sort: SortValue) => void
  t: TFunction
  classes: {
    sortSection: string
    sortTitle: string
  }
}

const FilterDrawerSort = ({
  doc,
  sort,
  onSortChange,
  t,
  classes,
}: FilterDrawerSortProps) => {
  const {
    defaultSortValue,
    enableSorting,
    sortingOptions,
    sortToString,
    stringToSort,
  } = useShopSorting(doc, t)

  if (!enableSorting || sortingOptions.length === 0) {
    return null
  }

  const sortingValue = sortToString(sort || defaultSortValue)

  const handleChange = (
    _event: React.ChangeEvent<HTMLInputElement>,
    value: string
  ) => {
    onSortChange(stringToSort(value))
  }

  return (
    <div className={classes.sortSection}>
      <Typography
        component="p"
        variant="body1"
        color="primary"
        className={classes.sortTitle}
      >
        <CMSText
          asText
          data={doc?.data?.sort_title}
          defaultText={t('texts:shop:sort')}
        />
      </Typography>
      <RadioGroup value={sortingValue} onChange={handleChange}>
        {sortingOptions.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio color="primary" />}
            label={option.label}
          />
        ))}
      </RadioGroup>
    </div>
  )
}

export default FilterDrawerSort
